/** 获取路由参数的首个字符串值，缺失或类型不匹配时返回空字符串。 */
export const getRouteParamValue = (value: unknown): string => {
  if (Array.isArray(value)) {
    return typeof value[0] === 'string' ? value[0] : ''
  }

  return typeof value === 'string' ? value : ''
}
